import { render } from "./InvoiceCard.vue?vue&type=template&id=5b4d6d44"
import script from "./InvoiceCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__